import React from "react";
import styled from "styled-components";
import {connect} from "react-redux";

const AmenitiesContainer = styled.div`
  display: block;

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    flex-direction: row;
  }
`;

const AmenityWrapper = styled.div`
  display: flex;
  align-items: top;
  margin-right: 20px;
  margin-bottom: 3px;
`;

const CheckMark = styled.div`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 13px;

  img {
    position: relative;
    right: -5px;
    width: 20.19px;
    height: 20.19px;
    top: -3px;

    @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
      width: 23px;
      height: 23px;
    }

    @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
      width: 25.27px;
      height: 25.27px;
    }
  }
`;

function Amenities({amenities, activeTheme}) {
  const amenitiesFormatted = amenities
    .replaceAll("\n", "")
    .replace("᛫ ", "")
    .split("᛫ ");

  const checkMarkIcon = activeTheme === "dark" ? "check-icon.png" : "check-icon-purple.png"
  return (
    <AmenitiesContainer className="AmenitiesContainer">
      {
        amenitiesFormatted.map((amenity) => {
          return (
            <AmenityWrapper className="AmenityWrapper">
              <CheckMark className="circle">
                <img src={`/images/app-icons/${checkMarkIcon}`}/>
              </CheckMark>
              <span>{amenity}</span>
            </AmenityWrapper>
          )
        })
      }
    </AmenitiesContainer>
  )
}

const mapStateToProps = (state) => ({
  activeTheme: state.settings.activeTheme,
});

export default connect(mapStateToProps, null)(Amenities);
